import { render, staticRenderFns } from "./Page-2.vue?vue&type=template&id=23a04b96&scoped=true&"
var script = {}
import style0 from "./Page-2.vue?vue&type=style&index=0&id=23a04b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a04b96",
  null
  
)

export default component.exports